import getLignesCommandesWithReferenceEcheancier
  from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';
import genererEcheancierAuto from '@/services/commande/echeancierFacturation/genererEcheancierAuto';
import deleteLignesEcheanciersInutiles
  from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';

export default function fusionEcheancier(tabReferenceEcheancier, commande) {
  let lignes = [];
  tabReferenceEcheancier.forEach((referenceEcheancier) => {
    lignes = lignes.concat(getLignesCommandesWithReferenceEcheancier(
      commande.lignesCommande, referenceEcheancier,
    ));
  });
  const echeancier = genererEcheancierAuto(
    lignes, commande.datePremierAffichage, commande.dateDevisCommande,
  );
  lignes.forEach((ligne) => { ligne.referenceEcheancier = echeancier.referenceEcheancier; });
  commande.echeanciers.push(echeancier);
  deleteLignesEcheanciersInutiles(commande);
}
